"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncSpliterator = exports.AsyncPartsIterator = exports.AsyncPartIterator = exports.split = void 0;

var _asyncIterableIterator = require("./async-iterable-iterator");

var _asyncIteratorProxy = require("./async-iterator-proxy");

var _asyncConsumeIterator = require("./async-consume-iterator");

const split = Symbol('split');
exports.split = split;

async function* asyncWrap(source) {
  yield* source;
}

class AsyncPartIterator extends _asyncIterableIterator.AsyncIterableIterator {
  constructor(partsIterator) {
    super();
    this.partsIterator = partsIterator;
    this.spliterator = partsIterator.spliterator;
  }

  assertActive() {
    if (this !== this.partsIterator.activePart) {
      throw new Error('Cannot take from this split part. It is no longer the active part.');
    }
  }

  async next() {
    this.assertActive();
    const item = await this.spliterator.next();

    if (item.value === split) {
      this.partsIterator.activePart = null;
      await this.partsIterator.maybeReturnSource();
      return {
        value: undefined,
        done: true
      };
    } else if (item.done) {
      this.partsIterator.sourceDone = true;
      return {
        value: undefined,
        done: true
      };
    } else {
      return item;
    }
  }

  async return(value) {
    this.assertActive();
    this.partsIterator.activePart = null;
    await this.partsIterator.maybeReturnSource();
    return {
      value,
      done: true
    };
  }

  async throw(error) {
    this.assertActive();
    await this.spliterator.throw(error);
    return {
      value: undefined,
      done: true
    };
  }

}

exports.AsyncPartIterator = AsyncPartIterator;

class AsyncPartsIterator extends _asyncIterableIterator.AsyncIterableIterator {
  constructor(spliterator) {
    super();
    this.spliterator = spliterator;
    this.sourceDone = false;
    this.returned = false;
    this.activePart = null;
  }

  async maybeReturnSource() {
    if (this.returned && !this.activePart) {
      await this.spliterator.return();
    }
  }

  async next() {
    if (this.activePart) {
      await (0, _asyncConsumeIterator.asyncConsumeIterator)(this.activePart);
    }

    if (this.spliterator === null || this.sourceDone) {
      return {
        value: undefined,
        done: true
      };
    } else {
      this.activePart = new AsyncPartIterator(this);
      return {
        value: asyncWrap(this.activePart),
        done: false
      };
    }
  }

  async return(value) {
    this.returned = true;
    await this.maybeReturnSource();
    return {
      value,
      done: true
    };
  }

  async throw() {
    return this.return();
  }

}

exports.AsyncPartsIterator = AsyncPartsIterator;

class AsyncSpliterator extends _asyncIteratorProxy.AsyncIteratorProxy {}

exports.AsyncSpliterator = AsyncSpliterator;